import './mainPage.css';

import { useState } from 'react';
import AnnouncementBar from './AnnouncementBar';
import CategorySection from './CategorySection';
import FeatureSection from './FeatureSection';
import Footer from './Footer';
import Header from './Header';
import Hero from './Hero';
import MainProducts from './MainProducts';
import Newsletter from './Newsletter';
import ProductSection from './ProductSection';
import ShowcaseSection from './ShowcaseSection';
import ProviderCallout from './ProviderCallout';

import {
  categories,
  featureItems,
  featuredProducts,
  heroStats,
  navItems,
  newArrivals,
  showcaseCards,
  weeklyDeals,
} from './data/mockData';

const MainPage = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const hasSearch = searchTerm.trim().length > 0;

  return (
    <div className="app-shell">
      <AnnouncementBar />
      <Header navItems={navItems} searchValue={searchTerm} onSearchChange={setSearchTerm} />

      {hasSearch ? (
        <MainProducts searchTerm={searchTerm} onClearSearch={() => setSearchTerm('')} />
      ) : (
        <>
          <ProviderCallout />
          <Hero stats={heroStats} />
          <FeatureSection features={featureItems} />
          <CategorySection categories={categories} />

          <ProductSection
            id="destacados"
            overline="Productos destacados"
            title="Seccion principal tipo home"
            description="Inspirada en el formato de vitrina del sitio base, con cards de producto listas para reemplazar por datos reales."
            products={featuredProducts}
          />

          <ShowcaseSection cards={showcaseCards} />

          <ProductSection
            id="novedades"
            overline="Nuevas llegadas"
            title="Bloque para novedades o vistos recientemente"
            description="Puedes usar esta seccion para campanas, historial o recomendaciones personalizadas."
            products={newArrivals}
          />

          <ProductSection
            id="ofertas"
            overline="Ofertas semanales"
            title="Espacio ideal para promociones temporales"
            description="Preparado para conectar descuentos reales, etiquetas automaticas y fechas de vigencia."
            products={weeklyDeals}
          />

          <Newsletter />
        </>
      )}

      <Footer />
    </div>
  );
};

export default MainPage;
